export default __webpack_public_path__ + "static/launch-partner_HanDAO_right@2x-1d2993d6f77fa289b04f4c91cbbadc4e.jpg";